export default __webpack_public_path__ + "static/media/instagramIcon.9f555351.png";